(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileWebNotificationsDebug', ["path", "troubleshooting", function (path, troubleshooting) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/common/web-notifications-debug').template('web-notifications-debug'),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.panel = {
                    'type': 'multi-widget',
                    'logic': {
                        'name': 'debugWebNotificationsLogic',
                        'updateTick': null
                    },
                    'wrapper': {
                        'type': 'widget-panel',
                        'title': 'Notifications',
                        'class': {
                            'avanan white-body overflow-auto': true,
                            'display-none': true
                        },
                        'buttons': [{
                                'class': 'btn-blue',
                                'label': 'Show notifications',
                                'position': 'right',
                                'id': 'toggle-notifications'
                            }]
                    },
                    'size': 'large',
                    'class': 'light',
                    'listWidget': {
                        'type': 'data-table',
                        'logic': { 'name': 'webNotificationsListLogic' },
                        'size': 'large no-padding',
                        'class': 'light',
                        'wrapper': { 'type': 'none' },
                        'options': {
                            'pagesAround': 2,
                            'pageSize': 100,
                            'pagination': { 'page': 1 },
                            'defaultOrdering': {
                                'columnName': 'time',
                                'order': 'desc'
                            }
                        },
                        'columns': [
                            {
                                'id': 'time',
                                'text': 'time',
                                'sortable': true,
                                'format': 'time',
                                'dataClass': 'white-space-nowrap'
                            },
                            {
                                'id': 'change_type',
                                'text': 'change_type'
                            },
                            {
                                'id': 'message_id',
                                'hidden': true
                            },
                            {
                                'id': '_fullData',
                                'text': 'Other data',
                                'converter': 'missingDataConverter'
                            }
                        ]
                    }
                };
            }
        };
    }]);
}());